import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { saveOrganization, updateOrganization } from "@/service/structure";
import _ from "lodash";
export default {
  name: "add_module",
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    item: {
      type: null,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      modal: {
        visible: false,
        loading: false,
        title: $t("d7etf24", "新增部门")
      },
      formObj: {
        parentId: "",
        name: "",
        listOrder: "0"
      },
      ruleCustom: {
        name: [{
          required: true,
          message: $t("2jb6fo5", "请输入名称"),
          trigger: "blur"
        }, {
          pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]{2,25}$/,
          message: $t("pmcb1hj", "仅支持字母数字汉字2-25个字符的命名")
        }]
      }
    };
  },
  watch: {
    visible(val) {
      val && this.init();
      this.modal.visible = val;
    }
  },
  methods: {
    /* 提交事件 */
    onCommit() {
      /* 验证 */
      this.$refs["formCustom"].validate(async valid => {
        if (valid) {
          this.modal.loading = true;
          if (this.item && this.item.type === "edit") {
            const params = {
              name: _.trim(this.formObj.name),
              id: this.item.id
            };
            let res = await updateOrganization(params);
            if (res.data && res.data.result === 0) {
              this.$Message.success($t("ai8d7e4", "修改成功"), this.item.orgId);
              this.$emit("update", this.item.orgId);
              this.clean();
            }
          } else {
            const params = {
              ...this.formObj,
              name: _.trim(this.formObj.name)
            };
            let res = await saveOrganization(params);
            if (res.data && res.data.result === 0) {
              this.$Message.success($t("d76ha54", "新增成功"));
              this.$emit("update", this.item.orgId);
              this.clean();
            }
          }
          this.modal.loading = false;
        }
      });
    },
    /* 不显示弹窗 */
    clean() {
      this.$emit("close");
      this.$refs["formCustom"].resetFields();
      Object.keys(this.formObj).forEach(v => {
        this.formObj[v] = "";
      });
    },
    init() {
      this.modal.title = $t("enc3e35", "添加子部门");
      if (this.item.type === "edit") {
        // 截取formObj需要的字段值
        Object.keys(this.item).map(v => {
          if (Object.prototype.hasOwnProperty.call(this.formObj, v)) {
            this.formObj[v] = `${this.item[v]}`;
          }
          return v;
        });
        this.modal.title = $t("aigpcb4", "修改部门");
      }
      this.formObj.parentId = this.item.orgId ? this.item.orgId : "0";
    }
  }
};